import { Component } from '@angular/core';

@Component({
    selector: 'ts-page-not-authorized',
    templateUrl: './page-not-authorized.component.html',
    styleUrls: ['./page-not-authorized.component.css'],
    standalone: false
})
export class PageNotAuthorizedComponent {}
